import { useState, useEffect } from "react";
import { Row, Col, Drawer, Dropdown, Menu, Avatar } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
    HeaderSection,
    LogoContainer,
    Burger,
    NotHidden,
    Menu as StyledMenu,
    CustomNavLinkSmall,
    Label,
    Outline,
    Span,
    Username,
} from "./styles";
import { NavLink, useHistory } from "react-router-dom";
import { auth } from "../../firebase-config";

interface UserData {
    name: string | null;
    photo: string | null;
}

const Header = ({ t }: { t: TFunction }) => {
    const [visible, setVisibility] = useState(false);
    const [userData, setUserData] = useState<UserData>({
        name: null,
        photo: null,
    });
    const history = useHistory();

    const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const target = e.target as HTMLImageElement;
        target.onerror = null;
        setUserData(prev => ({
            ...prev,
            photo: '/default-avatar.png'
        }));
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                const providerData = user.providerData[0];
                const processedPhoto = (providerData?.photoURL || user.photoURL)
                    ?.replace(/(=s)\d+(-c)?/gi, '$1400') || null;

                setUserData({
                    name: user.displayName || providerData?.displayName || "",
                    photo: processedPhoto
                });

                localStorage.setItem("username", user.displayName || "");
                localStorage.setItem("photoURL", processedPhoto || "");
            }
        });

        const storedUsername = localStorage.getItem("username");
        const storedPhoto = localStorage.getItem("photoURL");

        if (storedUsername || storedPhoto) {
            setUserData({
                name: storedUsername,
                photo: storedPhoto?.replace(/(=s)\d+(-c)?/gi, '$1400') || null
            });
        }

        return () => unsubscribe();
    }, []);

    const toggleButton = () => setVisibility(!visible);

    const handleLogout = () => {
        localStorage.clear();
        setUserData({ name: null, photo: null });
        auth.signOut();
        history.push("/");
    };

    const menu = (
        <Menu>
            <Menu.Item key="user-info" disabled>
                <div style={{ display: "flex", alignItems: "center", padding: 8 }}>
                    <Avatar
                        src={userData.photo}
                        //@ts-ignore
                        onError={handleAvatarError}
                        size={40}
                        style={{ marginRight: 10 }}
                    />
                    <div>
                        <div style={{ fontWeight: 500 }}>{userData.name}</div>
                    </div>
                </div>
            </Menu.Item>
            <Menu.Item key="logout" onClick={handleLogout}>
                <Span>{t("Выйти")}</Span>
            </Menu.Item>
        </Menu>
    );

    const MenuItem = () => {
        return (
            <>
                <CustomNavLinkSmall onClick={() => history.push("/about-us")}>
                    <Span>{t("О нас")}</Span>
                </CustomNavLinkSmall>

                <CustomNavLinkSmall onClick={() => history.push("/privacy-policy")}>
                    <Span>{t("Безопасность")}</Span>
                </CustomNavLinkSmall>

                {userData.name ? (
                    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
                        <Username>
                            <Avatar
                                src={userData.photo}
                                //@ts-ignore

                                onError={handleAvatarError}
                                size={32}
                                style={{ marginRight: 8 }}
                            />
                            <Span>{userData.name}</Span>
                        </Username>
                    </Dropdown>
                ) : (
                    <CustomNavLinkSmall>
                        <NavLink to="/Auth/SingIn">
                            {/*                        //@ts-ignore*/}
                            <Button>
                                {t("Авторизация")}
                            </Button>
                        </NavLink>
                    </CustomNavLinkSmall>
                )}
            </>
        );
    };

    return (
        <HeaderSection>
            <Container>
                <Row justify="space-between" align="middle">
                    <LogoContainer to="/" aria-label="homepage">
                        <SvgIcon src="logo.svg" width="250px" height="64px" />
                    </LogoContainer>

                    <NotHidden>
                        <MenuItem />
                    </NotHidden>

                    <Burger onClick={toggleButton}>
                        <Outline />
                    </Burger>
                </Row>

                <Drawer
                    closable={false}
                    open={visible}
                    onClose={toggleButton}
                    bodyStyle={{ padding: 20 }}
                >
                    <Col style={{ marginBottom: "2.5rem" }}>
                        <Label onClick={toggleButton}>
                            <Col span={12}>
                                <StyledMenu>{t("Меню")}</StyledMenu>
                            </Col>
                            <Col span={12}>
                                <Outline style={{ marginLeft: "100px" }} />
                            </Col>
                        </Label>
                    </Col>
                    <MenuItem />
                </Drawer>
            </Container>
        </HeaderSection>
    );
};

export default withTranslation()(Header);
